import { jsx, jsxs } from 'react/jsx-runtime';
import React__default, { useRef, useCallback } from 'react';
import { useBinding } from '../useBinding/useBinding.js';
import { TreeContentContext } from './useTreeContent.js';
import { treeControllerFromUpdateState, TreeControllerContext, noopUpdateState } from './useTreeController.js';
import { useTreeLoader } from './useTreeLoader.js';

function TreeContainer({
  source,
  defaultState,
  state,
  onStateChange,
  rootElement,
  render,
  children,
  loaderOptions
}, _) {
  const controller = useRef(treeControllerFromUpdateState(noopUpdateState));
  const [innerState, setInnerState] = useBinding(defaultState, state, onStateChange, {});
  const tree = useTreeLoader(source, innerState, loaderOptions);
  controller.current.updateState = useCallback(updater => {
    setInnerState(updater(innerState, tree));
  }, [innerState, setInnerState, tree]);
  return jsx(TreeContentContext.Provider, {
    value: tree,
    children: jsxs(TreeControllerContext.Provider, {
      value: controller.current,
      children: [rootElement && React__default.createElement(rootElement, {
        tree
      }), render === null || render === void 0 ? void 0 : render({
        tree
      }), children]
    })
  });
}

export { TreeContainer };
//# sourceMappingURL=TreeContainer.js.map
